import { MutationCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { getErrorDescription, getErrorMessage } from '@fortem-monorepo/web-sdk'

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.options.onError) {
        return
      }

      toast.error(getErrorMessage(error), {
        description: getErrorDescription(error),
      })
    },
  }),
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, refetchOnMount: false } },
})

queryClient.setQueryDefaults(['instrument'], {
  gcTime: Infinity,
})
